import React, { useContext, useEffect, useState } from 'react'
import AgoraSignallingComponent from 'src/components/AgoraSingallingComponent/AgoraSignallingComponent'
import { DISPATCH_EVENT_KEYS } from 'src/consumer/constants'
import { ProfileContext } from 'src/consumer/context/ProfileContext'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'

export default function AgoraSignallingComponentForMentors() {
  const { profileData } = useContext(ProfileContext)
  const roles = getAllRolesInBoolean()
  const [userId, setUserId] = useState(profileData?.userId)

  const shouldInitialize = roles.isTeacher

  useEffect(() => {
    if (profileData?.userId) {
      setUserId(profileData?.userId)
    }
  }, [profileData])

  if (!shouldInitialize) return <></>
  
  // Don't render until userId is available to prevent initialization warnings
  if (!userId) return null

  return (
    <AgoraSignallingComponent
      deviceId={userId}
      dispatchEventKey={DISPATCH_EVENT_KEYS.mentorSignalingEvent}
    />
  )
}
